export default __webpack_public_path__ + "static/media/6ixer08.0ee6565d.jpg";